module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boodschapp"
  }, [_c('main-header'), _vm._v(" "), _c('product-counter'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.icon.length > 0) ? _c('v-btn', {
    ref: "fab",
    staticStyle: {
      "bottom": "28px",
      "color": "rgba(0,0,0,.87)",
      "position": "fixed"
    },
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "primary"
    },
    on: {
      "click": _vm.fab
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('v-icon', {
    key: _vm.icon
  }, [_vm._v(_vm._s(_vm.icon))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84363bce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/app/Boodschapp.vue
// module id = 494
// module chunks = 1